import Vue from "vue";
import Router from "vue-router";

import { ROUTES } from "../helpers/constants";
import { checkAuthRequired } from "./guards";

import NotFoundView from "../views/NotFoundView";

import DigitalEventView from "../views/DigitalEventView";
import Room from "../components/DigitalEvent/RoomList/Room/Room";
import RoomList from "../components/DigitalEvent/RoomList/RoomList";

import Auth from "../components/DigitalEvent/Auth/Auth";
import Login from "../components/DigitalEvent/Auth/Login";
import SetPassword from "../components/DigitalEvent/Auth/SetPassword";
import CreateAccount from "../components/DigitalEvent/Auth/CreateAccount";
import ConfirmAccount from "../components/DigitalEvent/Auth/ConfirmAccount";
import ConfirmNewPassword from "../components/DigitalEvent/Auth/ConfirmNewPassword";
import SetNewPassword from "../components/DigitalEvent/Auth/SetNewPassword";
import TableInfo from "../components/DigitalEvent/Auth/TableInfo";
import ResetTempPassword from "../components/DigitalEvent/Auth/ResetTempPassword";
import Logout from "../components/DigitalEvent/Auth/Logout";

Vue.use(Router);

/* eslint-disable */
let router = new Router({
  routes: [
    /** Default route -> Digital event */
    { path: "/", redirect: "/event" },

    /** Authentication module */
    {
      path: "/auth", component: Auth,
      children: [
        { path: "", name: ROUTES.DIGITAL_EVENT_AUTH, redirect: { name: ROUTES.DIGITAL_EVENT_AUTH_LOGIN } },
        { path: "logout", name: ROUTES.DIGITAL_EVENT_AUTH_LOGOUT, component: Logout },
        { path: "login", name: ROUTES.DIGITAL_EVENT_AUTH_LOGIN, component: Login },
        { path: "password", name: ROUTES.DIGITAL_EVENT_AUTH_SET_PASSWORD, component: SetPassword },
        { path: "register", name: ROUTES.DIGITAL_EVENT_AUTH_CREATE_ACCOUNT, component: CreateAccount },
        { path: "confirm-account", name: ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_ACCOUNT, component: ConfirmAccount },
        { path: "password/confirm", name: ROUTES.DIGITAL_EVENT_AUTH_CONFIRM_NEW_PASSWORD, component: ConfirmNewPassword },
        { path: "password/new", name: ROUTES.DIGITAL_EVENT_AUTH_SET_NEW_PASSWORD, component: SetNewPassword },
        { path: "password/reset-temp", name: ROUTES.DIGITAL_EVENT_AUTH_RESET_TEMP_PASSWORD, component: ResetTempPassword },
        { path: "welcome", name: ROUTES.DIGITAL_EVENT_AUTH_TABLE_INFO, component: TableInfo, meta: { requiresAuth: true } },
      ]
    },

    /** Digital event module */
    {
      path: "/event", component: DigitalEventView, meta: { requiresAuth: true },
      children: [
        { path: "", redirect: "rooms", meta: { requiresAuth: true } },
        { path: "rooms", name: ROUTES.DIGITAL_EVENT_ROOM_LIST, component: RoomList, meta: { requiresAuth: true },
          children: [
            { path: ":roomSlug", name: ROUTES.DIGITAL_EVENT_ROOM, component: Room, meta: { requiresAuth: true } }
          ]
        }
      ]
    },

    /** Not found page */
    { path: "*", component: NotFoundView }
  ]
});

router.beforeEach(async (to, from, next) => {
  await checkAuthRequired(from, to, next);
});

export default router;
